module.exports = __webpack_public_path__ + "static/img/10045.1119b236.png";